module.exports = __webpack_public_path__ + "assets/img/avatar.6aaa9769.png";